export default {"id":"92a64cea","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}